import { Component, OnInit, ElementRef } from '@angular/core';
import { PageBase } from 't4core';
import { AppIntegrationService } from 't4-app-integration';

@Component({
    selector: 'app-nfcRequired',
    templateUrl: './nfcRequired.html',
    standalone: false
})
export class NfcRequiredComponent extends PageBase implements OnInit {

  constructor(el: ElementRef, private appService: AppIntegrationService) {
    super(el);
  }

  ngOnInit(): void { }

  public override secondTick() {
    this.appService.requestDeviceState();
  }
}
